import front from "./exam_cat_front.svg";
import back from "./exam_cat_back.svg";

const cat = {
  front,
  back,
};

export default cat;
